import { useEffect, useRef, useState } from "react";

import "./ModalFileUpload.css";

import { Modal } from "react-bootstrap";

import { LABEL_UPLOAD_FILE } from "../../utils/constant";

const ModalFileUpload = ({
  handleCancel,
  handleUpload,
  title = LABEL_UPLOAD_FILE,
  acceptTypes = ".jpg,.jpeg,.png,.mp4",
  errorMessage = "",
  isLoading = false,
  ...props
}) => {
  const fileInputRef = useRef(null);
  const [currentFileUpload, setCurrentFileUpload] = useState(undefined);

  useEffect(() => {
    if (props.show === false) {
      setCurrentFileUpload(undefined);
    }
  }, [props.show]);

  const handleFileChange = (event) => {
    let file = event.target.files[0];
    setCurrentFileUpload(file);
  };
  
  return (
    <Modal {...props} onHide={handleCancel} size="lg">
      <Modal.Header className="modal-header-custom">
        <Modal.Title className="modal-title-custom">{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body className="modal-body-custom">
        <div className="upload-file-container">
          <p>Please click Icon below to select file to upload</p>
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
            accept={acceptTypes}
          />
          <button
            className="upload-file-button"
            onClick={() => fileInputRef.current.click()}
          >
            {currentFileUpload ? currentFileUpload.name : LABEL_UPLOAD_FILE}
          </button>
        </div>
        <p className="text-danger mt-2">{errorMessage}</p>
      </Modal.Body>

      <Modal.Footer className="modal-footer-custom">
        {isLoading && <>Uploading now...</>}

        {!isLoading && (
          <>
            <button
              className="upload-btn"
              onClick={() => handleUpload(currentFileUpload)}
            >
              Upload
            </button>
            <button className="icon-btn" onClick={handleCancel}>
              Cancel
            </button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ModalFileUpload;
